/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Button,
  DataGrid,
  Grid,
  Input,
  Table,
} from '../../components/index';
import Exigencia from './Exigencia';
import Motivo from './Motivo';
import {
  trataMensagemSucesso,
  trataMensagensErro,
  requestExigencias,
  requestMotivos,
  requestExigenciasRPPS
} from '../../utils/requests';
import * as listUtils from '../../utils/listsSelect';
import User from '../../domain/User';
import {
  doMultipartFormPost,
  doDeleteMotivo,
} from '../../utils/requests';
import { tamanhoMaximoArquivoUpload } from '../../utils/constants';
import UploadDragDrop from '../../components/ComponentesBasicos/UploadDragDrop';

class ResultadoAnalise extends Component {
  constructor(props) {
    super(props);
    this.state = {
      acaoModal: 'Inclusão de Exigência',
      exigenciaSelecionada: null,
      showModal: false,
      acaoModalMotivo: 'Inclusão de Motivo',
      motivoSelecionado: null,
      showModalMotivo: false,
      indexExclusao: null,
      motivo: {
        protocolo: null,
        dataInicio: null,
        estado: null,
        justificativaIndeferimento: null,
        motivo: null,
        nomeArquivo: null,
        descricao: null,
      },
      arquivo: {
        documento: null,
        protocolo: null,
        tipoDocumento: null,
      },
      document: null,
      documents: [],
      tiposDisponiveis: [],
      tipoDocumento: null,
    };
  }

  componentDidMount() {
    this.montaListaDocumentosDisponiveis(null);
  }

  failCallback = () => {
    this.alteraEstado(6);
  }

  alteraEstado = (changeObj) => {
    this.props.alteraEstado(changeObj);
    if (changeObj.value === 2) {
      this.doRequest('exigencia');
    }
    if (changeObj.value === 9 || changeObj.value === 10) {
      this.doRequest('motivo');
    }
    if (changeObj.value === 8) {
      if (this.props.tipoRequerimento === 1) {
        const resultado = this.props.validacaoDeVinculosConcomitantes();
        this.props.atualizarVinculosConcomitantesConfirmado(resultado);
      }
    }
    this.montaListaDocumentosDisponiveis(changeObj.value);
  }

  handleModal = (callback) => {
    if (callback) {
      this.setState({ showModal: !this.state.showModal }, callback);
    } else {
      this.setState({ showModal: !this.state.showModal });
    }
  }
 
  mostraModal = (e, acaoModal) => {
    if (this.props.requerimento.estado === 9) {
      if (this.props.inIndefericaoAnalise) {
        this.doRequest('motivo');
      }
      this.setState({ acaoModal, motivoSelecionado: null }, this.handleModal);
    } else {
      this.setState({ acaoModal, exigenciaSelecionada: null }, this.handleModal);
    }
  }

  escondeModal = () => {
    this.handleModal();
  }

  alteraExigencia = (exigencia, title) => {
    this.setState({ acaoModal: title, exigenciaSelecionada: exigencia }, this.handleModal);
  }

  alteraMotivo = (motivo, title) => {
    this.setState({ acaoModalMotivo: title, motivoSelecionado: motivo }, this.handleModal);
  }

  salvaExigencia = (exigencia) => {
    const { exigencias } = { ...this.props.requerimento };
    const exigenciaExistente = exigencias.filter(item =>
      (exigencia.codigoDependente && item.codigoDependente ?
        (item.codigoDependente === exigencia.codigoDependente &&
          item.tipo === exigencia.tipo) : item.tipo === exigencia.tipo));

    if (exigenciaExistente.length > 0 && exigenciaExistente[0].index !== exigencia.index) {
      trataMensagensErro(['Não é possível adicionar duas exigências de mesma natureza.']);
    } else {
      if (!exigencia.codigoDependente) {
        // eslint-disable-next-line no-param-reassign
        delete exigencia.codigoDependente;
      }
      if (exigencia.index !== null) {
        exigencias[exigencia.index] = exigencia;
      } else {
        exigencias.push(exigencia);
      }
      this.handleModal(this.props.handleChange({
        value: exigencias,
        isValid: true,
      }, 'exigencias'));
    }
  }

  deleteExigencia = (index) => {
    const { exigencias } = { ...this.props.requerimento };
    exigencias.splice(index, 1);
    this.props.handleChange({
      value: exigencias,
      isValid: true,
    }, 'exigencias');
  }

  salvaMotivo = (paramMotivo) => {
    const { motivosIndeferimentoControle } = { ...this.props };
    const motivoExistente = motivosIndeferimentoControle.filter(item => item.motivo === paramMotivo.motivo);
    const url = 'requerimentos-compensacao/motivos';

    if (motivoExistente.length > 0 && motivoExistente[0].index !== paramMotivo.index) {
      trataMensagensErro(['Não é possível adicionar dois motivos de mesma natureza.']);
    } else {
      if (paramMotivo.arquivo) {
        paramMotivo.nomeArquivo = 'Documento de indeferimento';
        const tamanhoDocumentoUpload = paramMotivo.arquivo.size;
        if ((tamanhoDocumentoUpload > tamanhoMaximoArquivoUpload)) {
          trataMensagensErro([`Certifique-se de que o documento possui tamanho inferior a 3 mb.`]);
          return;
        }
      }
      if (paramMotivo.index !== null) {
        motivosIndeferimentoControle[paramMotivo.index] = paramMotivo;
      }
      this.setState({
        motivo: paramMotivo,
      });
      this.handleSaveMotivos(url, paramMotivo);
    }
  }

  deleteMotivo = (index) => {
    const { motivosIndeferimentoControle } = { ...this.props };
    const { requerimento } = { ...this.props };
    const motivo = motivosIndeferimentoControle[index];
    this.setState({
      indexExclusao: index,
    });
    const url = `requerimentos-compensacao/motivos/${requerimento.protocolo}/6/${motivo.dataInicio}/${motivo.motivo}`;
    doDeleteMotivo(
      url,
      this.trataSucessoResponseExclusaoArquivo,
      this.trataErrosResponseExclusaoArquivo,
      '',
      );
    }

    trataSucessoInclusaoMotivo = (response) => {
      const { motivosIndeferimentoControle } = { ...this.props };
      const { motivo } = { ...this.state };
      const motivoResponse = {
        protocolo: response.data.protocolo,
        dataInicio: response.data.dataInicio,
        estado: response.data.estado,
        comentario: response.data.comentario,
        motivo: response.data.motivo,
        descricao: response.data.descricao,
      }

      if (response.data.codigoDocumento) {
        motivo.codigoDocumento = response.data.codigoDocumento;
      }
      const obj = { ...motivo, ...motivoResponse };
      motivosIndeferimentoControle.push(obj);
      this.handleModal(this.props.handleChange({ value: motivosIndeferimentoControle, isValid: true, }, 'motivosIndeferimentoControle'));
      if (obj.arquivo !== null) {
        this.props.atualizarDocumentosProbatorios();
      }
      trataMensagemSucesso(['Motivo de indeferimento incluído com sucesso.']);
    }
    
    trataSucessoResponseExclusaoArquivo = () => {
    const { motivosIndeferimentoControle } = { ...this.props };
    this.props.handleChange({ value: motivosIndeferimentoControle, isValid: true }, 'motivosIndeferimentoControle');
    const motivo = motivosIndeferimentoControle[this.state.indexExclusao];
    motivosIndeferimentoControle.splice(motivo.index, 1);

    if (motivo.arquivo !== null) {
      this.props.atualizarDocumentosProbatorios();
    }
    this.setState({ motivosIndeferimentoControle });
    const mensagemSucesso = ['Motivo de indeferimento excluído com sucesso.'];
    trataMensagemSucesso(mensagemSucesso);
  }

  trataErrosResponseExclusaoArquivo = () => {
    const mensagemErro = ['Não foi possível excluir o motivo.'];
    trataMensagensErro(mensagemErro);
  }

  trataErrosResponse = (error) => {
    if (error) {
      if (error.status === 400) {
        if (error && error.data) {
          const { data } = { ...error };
          this.setState({
            chaveConfirmacao: data.chaveConfirmacao,
            alertas: data.alertas,
            showModalAlerta: !this.state.showModalAlerta,
          });
        }
      }
    }

    const mensagemErro = ['Falha ao incluir o motivo de indeferimento.'];
    trataMensagensErro(mensagemErro);
  }

  handleSaveMotivos = (url, motivo) => {
      let options;
      if (this.state.chaveConfirmacao) {
        options = { 'Chave-Confirmacao': this.state.chaveConfirmacao };
      }
      const { requerimento } = { ...this.props };

      if (motivo) {
          const body = {
            protocolo: requerimento.protocolo,
            motivo: motivo.motivo,
            justificativa: motivo.justificativaIndeferimento !== null ? motivo.justificativaIndeferimento : '',
          };
          if (motivo.arquivo) {
            body.arquivo = motivo.arquivo;
          }
          doMultipartFormPost(
            url,
            body,
            this.trataSucessoInclusaoMotivo,
            this.trataErrosResponse,
            options,
          );
      }
  }

  createCustomInsertButton = () => (
    <Button
      onClick={e => this.mostraModal(e, 'Inclusão de Exigência')}
      hint="Adicionar exigência"
      icon="ico-plus"
    />
  );

  createCustomInsertButtonMotivo = () => (
    <Button
      onClick={e => this.mostraModal(e, 'Inclusão de Motivo')}
      hint="Adicionar motivo"
      icon="ico-plus"
    />
  );

  createActionColumn = (index, exigencia) => (
    <React.Fragment>
      <Button
        hint="Editar exigência"
        icon="ico-pencil"
        mini
        onClick={() => this.alteraExigencia(exigencia, 'Edição de Exigência')}
      />
      <Button
        hint="Excluir exigência"
        icon="ico-minus"
        mini
        onClick={() => this.deleteExigencia(index)}
      />
    </React.Fragment>
  );

  createActionColumnMotivo = (index, motivo) => (
    <React.Fragment>
      <Button
        className = 'dtp-inverse'
        hint="Excluir motivo"
        icon="ico-doc-minus"
        mini
        onClick={() => this.deleteMotivo(index)}
      />
    </React.Fragment>
  );

  addDependenteLabel = (dependenteSelecionado) => {
    if (dependenteSelecionado) {
      const dependentesFormatados = this.props.requerimento.dependentes.map(dependente => (
        {
          label: dependente.nome,
          value: dependente.codigo,
        }
      ));
      return listUtils.getObject(dependentesFormatados, dependenteSelecionado).label;
    }
    return null;
  }

  doRequest = (typeRequest) => {
    switch (typeRequest) {
      case 'exigencia':
        if (this.props.exigencias.length === 0) {
          const { solicitante } = { ...this.props.requerimento };
          const { destinatario } = { ...this.props.requerimento };
          // ALTERAR O VALOR DO SOLICITANTE APOS OS TESTES
          if (solicitante.codigo !== '01000' && destinatario.codigo !== '01000') {
            requestExigenciasRPPS(this.failCallback);
          } else {
            requestExigencias(this.failCallback);
          }
        }
        break;
      case 'motivo':
        if (this.props.motivosIndeferimento.length === 0 &&
          this.props.motivosSuspensao.length === 0) {
          requestMotivos(this.failCallback);
        }
        break;
      default:
        break;
    }
  }

  diffTipoRequerimento = () => (this.props.requerimento.tipoAposentadoria)

  exigenciasTableHeaderAposentadoria = [{
    id: 'acao',
    label: 'Ação Exigida',
  }, {
    id: 'comentario',
    label: 'Comentário',
  }, {
    id: 'index',
    label: null,
    dataFormat: this.createActionColumn,
  }];

  exigenciasTableHeaderPensao = [{
    id: 'acao',
    label: 'Ação Exigida',
  }, {
    id: 'codigoDependente',
    label: 'Dependente',
    dataFormat: this.addDependenteLabel,
  }, {
    id: 'comentario',
    label: 'Comentário',
  }, {
    id: 'index',
    label: null,
    dataFormat: this.createActionColumn, 
  }];

  motivosTableHeader = [{
    id: 'descricao',
    label: 'Motivo',
  }, {
    id: 'comentario',
    label: 'Comentário',
  }, {
    id: 'nomeArquivo',
    label: 'Arquivo',
  }, {
    id: 'index',
    label: 'ações',
    dataFormat: this.createActionColumnMotivo,
  }];

  montarListaDocumentosAdicionais = (estado) => {
    let lista = [];
    const tiposDocumentos = this.props.tiposDocumentos ? this.props.tiposDocumentos : [];
    let codigos = [22, 23];

    if (estado === 8) {
      codigos = [23];
    }

    if (estado === 10) {
      codigos = [22];
    }

    lista = tiposDocumentos.filter(doc => (codigos.includes(doc.value)));
    return lista;
  }

  montaListaDocumentosDisponiveis = (estado) => {
    const lista = this.montarListaDocumentosAdicionais(estado);
    this.setState({
      tiposDisponiveis: lista,
    });
  }

  handleChange = (e, name) => {
    this.setState({
      [name]: e.value,
    });
  }

  render() {
    let complemento;
    let modal;
    let nota;
    let upload
    const options = {
      insertBtn: this.createCustomInsertButton,
      noDataText: 'Adicione uma exigência',
    };

    const optionsMotivos = {
      insertBtn: this.createCustomInsertButtonMotivo,
      noDataText: 'Adicione um motivo',
    };

    let peloMenosDoisRegimes = false;
    const colecao = this.props.requerimento.relacoesPrevidenciariasDestinatario;
    if (colecao) {
      peloMenosDoisRegimes = colecao.map(e => e.regimePrevidenciario).flat().length >= 2;
    }

    //if ((!User.logged().isRGPS()) && (this.props.requerimento.estado === 8 && this.props.vinculosConcomitantesConfirmado /*&& peloMenosDoisRegimes*/)) {
    if ((!User.logged().isRGPS()) && (this.props.requerimento.estado === 8 && this.props.possuiVinculosConcomitantes)) {		
      complemento = <h4>Vínculos concomitantes encontrados. Verifique a aba "Relações Previdenciárias Regime Origem"</h4>;
    }

    // Acao de deferir
    if (this.props.requerimento.estado === 8) {
      let retorno = false;
      if (this.props.tipoRequerimento === 1) {
        let resultado = this.props.validacaoDeVinculosConcomitantes();
        this.props.atualizarVinculosConcomitantesConfirmado(resultado);
        retorno = resultado.existeConcomitancia;
      }
      if (this.props.tipoRequerimento === 2) {
        retorno = false;
      }
      if (retorno === false) {
        nota = (
          <div className="row">
            <Grid cols="8 8 8 8">
              <Input
                cols="74"
                componentClass="textarea"
                label="Conclusão da análise"
                maxlength="200"
                onChange={e => this.props.handleChange(e, 'conclusaoAnalise')}
                rows="3"
                value={this.props.requerimento.conclusaoAnalise}
                textarea
              />
            </Grid>
          </div>  
        );
        upload = (
          <React.Fragment>
            <div className="row">
              <Grid cols="8 8 8 8">
                <p><b>Se desejar, anexe um documento para justificar o deferimento.</b></p>
              </Grid>
            </div>
            <div className="row">
              <Grid cols="8 8 8 8">
                <Input
                  label="Tipo de documento"
                  number
                  placeholder="Selecione o tipo de documento"
                  onChange={e => this.props.handleChangeTipoDocumento(e, 'tipoDocumento')}
                  value={this.props.tipoDocumento}
                  itemList={this.state.tiposDisponiveis}
                  custom
                />
              </Grid>
            </div>
            <UploadDragDrop
              files={this.state.document ? [this.state.document] : []}
              onChange={arquivos => this.setState({ document: arquivos[0] || null })}
              onSelect={arquivo => this.props.handleChangeFile(arquivo)}
              multiple={false}
              accept="application/pdf,.pdf"
              minHeight={70}
              titulo="Arraste o arquivo PDF aqui"
              subtitulo="ou clique para selecionar"
              largura="8"
              disabled={!this.props.tipoDocumento}
            />
          </React.Fragment>
        );
      }
    }

    // Acao de criar exigencias
    if (this.props.requerimento.estado === 2) {
      const { exigencias } = { ...this.props.requerimento };
      const listaExigenciasIndexada = exigencias.map((item, i) => {
        const itemIndexado = item;
        itemIndexado.index = i;
        return itemIndexado;
      });
      complemento = (
        <Table
          bordered
          data={listaExigenciasIndexada}
          insertRow
          options={options}
          listaTableHeader={
            this.diffTipoRequerimento()
            ? this.exigenciasTableHeaderAposentadoria
            : this.exigenciasTableHeaderPensao
          }
        />
      );
      if (this.state.showModal) {
        modal = (
          <Exigencia
            exigencias={this.props.exigencias}
            dependentes={this.props.requerimento.dependentes}
            tipoRequerimento={this.diffTipoRequerimento() ? 'aposentadoria' : 'pensao'}
            salvaExigencia={this.salvaExigencia}
            exigencia={this.state.exigenciaSelecionada}
            onHide={this.escondeModal}
            title={this.state.acaoModal}
            showModal
            size="md"
            userData={this.props.userData}
            solicitante={this.props.requerimento.solicitante}
            destinatario={this.props.requerimento.destinatario}
          />
        );
      }
    }
    // Acao de indeferir
    if (this.props.requerimento.estado === 9 || (this.props.inIndefericaoAnalise)) {
      const listaMotivosIndexada = this.props.motivosIndeferimentoControle.map((item, i) => {
        const itemIndexado = item;
        itemIndexado.index = i;
        itemIndexado.nomeArquivo = (itemIndexado.documento || itemIndexado.arquivo) ? 'Documento de indeferimento' : '';
        return itemIndexado;
      });
      complemento = (
        <Table
            bordered
            data={listaMotivosIndexada}
            insertRow
            options={optionsMotivos}
            listaTableHeader={this.motivosTableHeader}
          />
        );
        if (this.state.showModal) {
          modal = (
            <Motivo
              motivos={this.props.motivosIndeferimento}
              salvaMotivo={this.salvaMotivo}
              motivo={this.state.motivoSelecionado}
              onHide={this.escondeModal}
              title={this.state.acaoModalMotivo}
              showModal
              size="md"
              tipoRequerimento={this.props.tipoRequerimento}
              solicitante={this.props.requerimento.solicitante}
              destinatario={this.props.requerimento.destinatario}
              atualizarDocumentosProbatorios={this.props.atualizarDocumentosProbatorios}
            />
          );
        }
    }
    // Acao de Suspender
    if (this.props.requerimento.estado === 10) {
      let motivosSuspensaoFiltrado = [];
      const inss = '01000';
      const destinatarioOuSolicitanteRGPS = User.logged().isRGPS() ||
          this.props.requerimento.solicitante.codigo === inss;
      const acordos = (destinatarioOuSolicitanteRGPS) ? [1, 3] : [2, 3];
      if (this.props.requerimento.tipoAposentadoria) {
        motivosSuspensaoFiltrado = this.props.motivosSuspensao.filter(item => (
          item.abrangenciaAplicavel === 1 &&
          User.logged().codigosDeRegime().includes(item.regimeAplicavel) &&
          acordos.includes(item.acordoAplicavel)
        ));
      } else {
        motivosSuspensaoFiltrado = this.props.motivosSuspensao.filter(item => (
          item.abrangenciaAplicavel !== 1 &&
          User.logged().codigosDeRegime().includes(item.regimeAplicavel) &&
          acordos.includes(item.acordoAplicavel)
        ));
      }
      complemento = (
        <React.Fragment>
          <div className="row">
            <Grid cols="8 8 8 8">
              <Input
                itemList={motivosSuspensaoFiltrado}
                label="Motivo para a suspensão"
                onChange={e => this.props.handleChange(e, 'motivo')}
                placeholder="Selecione o motivo"
                value={this.props.requerimento.motivo}
              />
            </Grid>
          </div>
        </React.Fragment>
      );
      nota = (
        <React.Fragment>
          <div className="row">
            <Grid cols="8 8 8 8">
              <Input
                cols="74"
                componentClass="textarea"
                label="Observação da suspensão"
                maxlength="200"
                onChange={e => this.props.handleChange(e, 'conclusaoAnalise')}
                rows="3"
                value={this.props.requerimento.conclusaoAnalise}
                textarea
              />
            </Grid>
          </div>
        </React.Fragment>
      );
    }
    
    return (
      <React.Fragment>
        <DataGrid title="Análise" icon="ico-process-check" >
          <div className="row">
            <Grid cols="4 4 4 4">
              <Input
                itemList={listUtils.resultadoAnalise}
                label="Resultado da análise"
                onChange={e => this.alteraEstado(e)}
                placeholder="Selecione o resultado da análise"
                value={this.props.requerimento.estado}
              />
            </Grid>
          </div>
          <div className="row">
            <Grid cols="12 12 12 12">
              { complemento }
            </Grid>
          </div>
          <div className="row">
            <Grid cols="12 12 12 12">
              { nota }
            </Grid>
          </div>
          <div className="row">
            <Grid cols="12 12 12 12">
              { upload }
            </Grid>
          </div>
        </DataGrid>
        { modal }
      </React.Fragment>
    );
  }
}

ResultadoAnalise.propTypes = {
  alteraEstado: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  requerimento: PropTypes.shape({
    estado: PropTypes.number,
    exigencias: PropTypes.shape({
      tipo: PropTypes.number,
      comentario: PropTypes.string,
    }),
    tipoAposentadoria: PropTypes.number,
    motivo: PropTypes.number.isRequired,
    dependentes: PropTypes.array,
  }).isRequired,
  exigencias: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  })),
  motivosIndeferimento: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  })),
  motivosSuspensao: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  })),
  userData: PropTypes.objectOf(PropTypes.object),
  atualizarDocumentosProbatorios: PropTypes.func.isRequired,
  motivosIndeferimentoControle: PropTypes.array,
  validacaoDeVinculosConcomitantes: PropTypes.func.isRequired,
  atualizarVinculosConcomitantesConfirmado: PropTypes.func.isRequired,
  handleChangeFile: PropTypes.func.isRequired,
  handleChangeTipoDocumento: PropTypes.func.isRequired,
  tipoDocumento: PropTypes.number,
};

ResultadoAnalise.defaultProps = {
  motivosIndeferimento: null,
  motivosSuspensao: null,
  exigencias: null,
  userData: null,
  tiposDocumentos: [],
};

const mapStateToProps = state => ({
  exigencias: state.base.exigencias,
  motivosIndeferimento: state.base.motivosIndeferimento,
  motivosSuspensao: state.base.motivosSuspensao,
  tiposDocumentos: state.base.tiposDocumentos,
});
export default connect(mapStateToProps)(ResultadoAnalise);



// WEBPACK FOOTER //
// ./src/pages/requerimentos/ResultadoAnalise.jsx